import axios from "axios";
import Cookies from "js-cookie";
import AuthService from "./services/AuthService";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_URL,
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (config) => {
    if (
      ["POST", "PUT", "PATCH", "DELETE"].includes(config.method.toUpperCase())
    ) {
      const csrftoken = Cookies.get("csrftoken");
      if (csrftoken) {
        config.headers["X-CSRFToken"] = csrftoken;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { config: { url }, response: { status } } = error;
    if (status === 401 && url !== "login/") {
      AuthService.logout();
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
